import { apiEndpoint } from '@/configs/api/api-configs'
import { reactive } from '@vue/composition-api'

export default function customerDetailModel() {
  const fetchQueryDataDetailModel = reactive({
    api: `${apiEndpoint.bcrm_platform}/DynamicTable/QueryData_Detail`,
    method: 'POST',
    payload: {
      QueryDataId: null,
      QueryData_Key: null,
      Payloads: [{ Key: null, Value: null }],
      IsVerified: false
    },
  })

  const fetchOverallPrivilege = reactive({
    api: `${apiEndpoint.bcrm_platform}/Customer/Point_Detail`,
    method: 'POST',
    payload: {
      Customer_Id: 11,
    },
  })

  const fetchPointHistoryList = reactive({
    api: `${apiEndpoint.bcrm_platform}/Customer/Point_History`,
    method: 'POST',
    payload: {
      Customer_Id: 11,
      Page: 1,
      Limit: 999,
      Filters: [
        // {
        //   Seq: 1,
        //   Key: 'query',
        //   Value: '',
        // },
      ],
      Ordering: [
        // {
        //   Seq: 1,
        //   Key: 'tx_time',
        //   Direction: 'desc',
        // },
      ],
    },
  })

  const fetchPrivilegeHistoryList = reactive({
    api: `${apiEndpoint.bcrm_platform}/Customer/Privilege_History`,
    method: 'POST',
    payload: {
      Customer_Id: 11,
      Page: 1,
      Limit: 999,
      From_Date: '',
      To_Date: '',
    },
  })

  return {
    fetchQueryDataDetailModel,
    fetchOverallPrivilege,
    fetchPointHistoryList,
    fetchPrivilegeHistoryList,
  }
}
